import type { Middleware } from "redux";

import { logUserIn } from "../../../../store/state/user";
import { refresh, redirect } from "../../../../utils/window";

export const signinMiddleware: Middleware<{}, {}> = () => next => action => {
  switch (action.type) {
    case logUserIn.type:
      action.payload.redirect_url
        ? redirect(action.payload.redirect_url)
        : refresh();
      break;
  }

  return next(action);
};
